import dynamic from "next/dynamic";
export default dynamic(function() {
    return import("./store-map");
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                require.resolveWeak("./store-map")
            ];
        }
    },
    ssr: false
});
